// This icon file is generated automatically.
var PCustomerserviceOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6 0a6 6 0 00-6 6v5.63c0 .2.17.37.38.37h2.87a1 1 0 001-1V7.75a1 1 0 00-1-1H1.12V6a4.88 4.88 0 019.75 0v.75H8.75a1 1 0 00-1 1V11a1 1 0 001 1h2.88c.2 0 .37-.17.37-.38V6a6 6 0 00-6-6zM3.12 7.88v3h-2v-3h2zm7.75 3h-2v-3h2v3z", "fill-rule": "nonzero" } }] }, "name": "p-customerservice", "theme": "outlined" };
export default PCustomerserviceOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCustomerserviceOutlined.js
// module id = 3314
// module chunks = 0